import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setNotificationMessage, setNotificationStatus } from "@shared/ui";
import { NotificationType } from "@shared/ui";
import { useAppDispatch } from "@shared/ui";

import { settingsService } from "@shared/ui";

interface IConnectionSettings {
  droneId: string | undefined;
  isNew: boolean;
  isVPNConnected: boolean;
  setIsNew: (value: boolean) => void;
}

const ConnectionSettings: React.FC<IConnectionSettings> = ({
  droneId,
  isNew,
  isVPNConnected,
  setIsNew,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isVPN, setIsVPN] = useState(isVPNConnected);

  useEffect(() => {
    setIsVPN(isVPNConnected);
  }, [isVPNConnected]);

  const enableVPN = async () => {
    if (droneId) {
      await settingsService.enableVPN(droneId);
      setIsVPN(true);
    }
  };

  const disableVPN = async () => {
    if (droneId) {
      await settingsService.disableVPN(droneId);
      setIsVPN(false);
    }
  };
  const publish = async () => {
    if (droneId) {
      await settingsService.publishSettings(droneId);
      dispatch(
        setNotificationMessage({
          message: t("connectionSettings.notifications.settingsPublished"),
          type: NotificationType.Message,
        }),
      );
      dispatch(setNotificationStatus(true));
    }
  };

  const updateNewState = (state: boolean) => {
    if (droneId) {
      settingsService.setDroneNewState(droneId, state).then(() => {
        setIsNew(state);
      });
    }
  };

  return (
    <>
      <div className="p-20">
        <button className="btn" onClick={enableVPN} disabled={isVPN}>
          {t("connectionSettings.buttons.enableVPN")}
        </button>
        <button className="btn" onClick={disableVPN} disabled={!isVPN}>
          {t("connectionSettings.buttons.disableVPN")}
        </button>
        <button className="btn" onClick={publish}>
          {t("connectionSettings.buttons.publishSettings")}
        </button>

        <div className="mt-20">
          <div className="form-wrapper settings-form">
            <div className="input-wrapper input-wrapper-checkbox">
              <input
                type="checkbox"
                id="drone"
                checked={isNew}
                onChange={(event) => updateNewState(event.target.checked)}
              />
              <label htmlFor="drone">{t("connectionSettings.labels.newDroneId")}</label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectionSettings;
